import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=a2362208&lang=scss"

const __exports__ = script;

export default __exports__